/* Paginakop: één rij van 56 px (docs/ux/ontwerpsysteem.md). De lettermaat van de titel en de
   ondertitel staat in de globale klassen .page-title en .page-subtitle (apps/web styles/lists.css),
   zodat ook oudere schermen met een losse h1 dezelfde titel hebben. Hier alleen de indeling. */
.head {
  margin: 0 0 var(--b-space-16, 16px);
}

/* Past alles niet op één rij (lange titel, twee knoppen op de telefoon), dan gaan de knoppen naar
   een tweede regel; de titel wordt nooit smaller dan zijn woorden. WP2 houdt de rij kort (hooguit
   twee pictogramknoppen en één primaire knop). */
.row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--b-space-8, 8px);
  min-height: var(--b-page-head, 56px);
}

.title {
  flex: 0 1 auto;
  max-width: 100%;
  min-height: var(--b-page-head, 56px);
  display: flex;
  align-items: center;
}

.back {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  width: var(--b-touch, 44px);
  height: var(--b-touch, 44px);
  margin-inline-start: calc(-1 * var(--b-space-8, 8px));
  padding: 0;
  border: 0;
  border-radius: var(--b-radius-pill, 999px);
  background: transparent;
  color: var(--text);
  cursor: pointer;
}

.back:hover {
  background: var(--surface-hover);
}

.actions {
  display: flex;
  flex: 0 1 auto;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--b-space-8, 8px);
  margin-inline-start: auto;
}

.meta,
.subtitle {
  margin: 0;
  color: var(--text-muted);
}

.meta {
  font-size: var(--b-text-meta);
  font-weight: 600;
}

.subtitle {
  max-width: var(--b-readable, 720px);
}

/* Paginabalk: tabs of segment direct onder de kop. */
.bar {
  margin: 0 0 var(--b-space-16, 16px);
}

@media (max-width: 839.98px) {
  .sticky {
    position: sticky;
    top: var(--b-sticky-top, 0px);
    z-index: 5;
    margin-inline: calc(-1 * var(--b-page-gutter, 16px));
    padding: 0 var(--b-page-gutter, 16px);
    background: var(--surface-canvas);
  }
}

@media (min-width: 840px) {
  .head {
    margin-bottom: var(--b-space-24, 24px);
  }
}

/* Tabs of een segment in de balk: de balk bepaalt de ruimte eronder (geen dubbele marge). */
.bar > * {
  margin-bottom: 0;
}
